import { SubmitButton } from "components/common/buttons/SubmitButton";
import { cdn } from "constants/common";
import moment from "moment";
import React from "react";
import { Table } from "reactstrap";

const InvoiceTable = ({ item, onMarkInvoiceAsPaid }) => {
  // const formattedDate = moment(timeZone).format('MMMM DD YYYY, hh:mm A');
  const renderTableHeader = React.useCallback(() => {
    return (
      <tr>
        <th className="col-3">Invoice</th>
        <th className="col-2">Status</th>
        <th className="col-2">Generated At</th>
        <th className="col-2">Paid At</th>
        <th className="col-2">Updated By</th>
        <th className="col-2">Actions</th>
      </tr>
    );
  }, []);

  const renderTableContent = React.useCallback((item) => {
    return <LogItem item={item} key={item?.id} onMarkInvoiceAsPaid={onMarkInvoiceAsPaid} />;
  }, [onMarkInvoiceAsPaid]);

  return (
    <div className="table_responsive">
      <table className="table">
        <thead className="text-primary">{renderTableHeader()}</thead>
        <tbody>
          {item?.translation_invoices &&
            renderTableContent(item?.translation_invoices)}
        </tbody>
      </table>
    </div>
  );
};


const LogItem = ({ item, onMarkInvoiceAsPaid }) => {
  const generatedAt = moment(item?.created_at).format(
    "MMM D, YYYY HH:mm:ss"
  );
  console.log("itemesdsdsd", item)
  const paidAt = item?.paid_at ? moment(item?.paid_at).format(
    "MMM D, YYYY HH:mm:ss"
  ): 'N/A';
  return (
    <tr>
      <td className="col-3">
        <a href={cdn + item?.invoice_path} target="_blank">{item?.invoice_number || "N/A"}</a>
      </td>
      <td className="col-2">
        {item?.status == 'paid' ? 'Paid': 'Pending'}
      </td>
      <td className="col-2">{generatedAt ?? 'N/A'}</td>
      <td className="col-2">{paidAt ?? 'N/A'}</td>
      <td className="col-2">{item?.updated_by?.name}</td>
      <td className="col-2">
        {paidAt == 'N/A' &&
        <SubmitButton
          buttonType="button"
          className={"lightBlue"}
          btnText="Mark Invoice as Paid"
          handleSubmit={onMarkInvoiceAsPaid}
          style={{ fontSize: '12px' }}

        />
        }
      </td>
    </tr>
  );
};
export default InvoiceTable;
